export default {
    methods: {
        toggleClassInBody(themeClass) {
            if (themeClass != '') document.body.classList.add(themeClass);
        },

        exibeImagem(caminhoImagem) {
            if (caminhoImagem != null && caminhoImagem != "") {
                return true;
            } else {
                return false;
            }
        },

        formatarPreco(value) {
            let val = (value / 1).toFixed(2).replace(".", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },

        removeEspacoCaracterEspecial(string) {
            return string.normalize("NFD").replace(/[^a-zA-Zs]/g, '')
        },

        containsKey(obj, key) {
            return Object.keys(obj).includes(key);
        }
    }
}